module.exports = __webpack_public_path__ + "img/diagnosa@2x.3a063313.png";